export enum MaterialType {
  aluminum = "알루미늄",
  steel = "강철",
  copper = "구리",
  carbonSteel = "탄소강",
  stainlessSteel = "스테인리스강",
}
